import { PipeTransform, Pipe } from '@angular/core';

interface Item {
  label: string;
  value: number;
}

@Pipe({ name: 'appSortByNumber' })
export class SortByNumberPipe implements PipeTransform {
  constructor() {}

  compare(a: Item, b: Item) {
    if (Number(a.label) < Number(b.label)) {
      return -1;
    }
    if (Number(a.label) > Number(b.label)) {
      return 1;
    }
    return 0;
  }

  transform(refinements: Array<Item>): Array<Item> {
    return refinements.sort(this.compare);
  }
}
